import { ChainId, Token } from '@sushiswap/core-sdk'

export const WETH = new Token(ChainId.PALM, '0x726138359C17F1E56bA8c4F737a7CAf724F6010b', 18, 'WETH', 'Wrapped Ether')
export const DAI = new Token(ChainId.PALM, '0x4C1f6fCBd233241bF2f4D02811E3bF8429BC27B8', 18, 'DAI', 'Dai Stablecoin')
